// Native
import { useState } from "react"

// Components
import { Button, ButtonGroup, AlertDialogBody, AlertDialogFooter, useToast, ModalBody, ModalFooter } from "@chakra-ui/react"
import { Alert, Dialog, Form, Modal } from "components"

// Config
import { API } from "config"

export default function Block({ data:distributor, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ form, setForm ] = useState({})
    const [ errors, setErrors ] = useState()
    const [ loading, setLoading ] = useState(false)
    const blocked_at = distributor?.blocked_at

    const handleBlock = async () => {
        setLoading(true)
        
        try{
            await API.put(`/distributors/${distributor?.id}/block`, form)
            toast({ title: 'O núcleo foi bloqueado', status: 'info' })
            onSuccess()
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível bloquear o núcleo agora.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    const handleUnblock = async () => {
        setLoading(true)
        
        try{
            await API.put(`/distributors/${distributor?.id}/unblock`)
            toast({ title: 'O núcleo foi bloqueado', status: 'info' })
            onSuccess()
            props.onClose()
        }catch(err){
            toast({ title: 'Não foi possível continuar.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }
    
    if(blocked_at) return(
        <Dialog title={`Desbloquear ${distributor?.title}?`} loading={loading} {...props}>
            <AlertDialogBody>
                <Alert status="warning" children="Ao desbloquear o núcleo, ele poderá acessar novamente o escritório de núcleos." />
            </AlertDialogBody>
            <AlertDialogFooter>
                <ButtonGroup size="sm" isDisabled={loading}>
                    <Button children="Desbloquear núcleo" isLoading={loading} onClick={handleUnblock} />
                    <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
                </ButtonGroup>
            </AlertDialogFooter>
        </Dialog>
    )

    return(
        <Modal title={`Bloquear ${distributor?.title}?`} loading={loading} {...props}>
            <ModalBody>
                <Alert status="warning" children="Ao bloquear o núcleo, ele terá todos as sessões desconectadas e não poderá entrar no escritório até o desbloqueio." />

                <Form.Form mt={6}>

                    <Form.Textarea
                        label="Motivo do bloqueio:"
                        name="blocked_reason"
                        value={form?.blocked_reason}
                        error={errors?.blocked_reason}
                        onChange={e => setForm({ blocked_reason: e.target.value })}
                        helper="Esta mensagem não será exibida para o núcleo."
                        placeholder="Ex.: Núcleo bloqueado devido à inatividade..."
                        isDisabled={loading}
                    />

                </Form.Form>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup size="sm" isDisabled={loading}>
                    <Button children="Bloquear núcleo" isLoading={loading} onClick={handleBlock} />
                    <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    )
}